module.exports = __webpack_public_path__ + "img/impresora.f69eafcb.svg";